import * as React from "react";
import { cn } from "@src/lib/utils/cn";

const ButtonGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex items-center [&>*:not(:first-child)]:rounded-l-none [&>*:not(:last-child)]:rounded-r-none [&>*:not(:first-child)]:border-white/10",
      className,
    )}
    {...props}
  >
    {children}
  </div>
));
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
